class ToggleableKlaviyoForms extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.formIds = []
    this.activeForm = 'email'
    this.emailForm = document.querySelector('.klaviyo-form[data-email]')
    if (this.emailForm?.dataset?.formId) {
      this.formIds.push(this.emailForm.dataset.formId)
    }
    this.smsForm = document.querySelector('.klaviyo-form[data-sms]')
    if (this.smsForm?.dataset?.formId) {
      this.formIds.push(this.smsForm.dataset.formId)
    }
    this.toggleButton = document.querySelector('.klaviyo-form-toggle')
    this.toggleButton.addEventListener('click', this.toggleForm.bind(this))
    window.addEventListener('klaviyoForms', this.onKlaviyoEvent.bind(this))
  }

  toggleForm() {
    if (this.activeForm === 'email') {
      this.activeForm = 'sms'
      this.emailForm.classList.remove('is-active')
      this.smsForm.classList.add('is-active')
      this.smsForm.querySelector('input').focus()
      this.toggleButton.textContent = 'Email me instead.'
    } else {
      this.activeForm = 'email'
      this.emailForm.classList.add('is-active')
      this.smsForm.classList.remove('is-active')
      this.emailForm.querySelector('input').focus()
      this.toggleButton.textContent = 'Text me instead.'
    }
  }

  onKlaviyoEvent(e) {
    if (e.detail.type === 'stepSubmit') {
      if (this.formIds.includes(e.detail.formId)) {
        if (this.toggleButton) {
          this.toggleButton.remove()
        }
        window.removeEventListener(
          'klaviyoForms',
          this.onKlaviyoEvent.bind(this)
        )
      }
    }
  }

  disconnectedCallback() {
    this.toggleButton.removeEventListener('click', this.toggleForm.bind(this))
    window.removeEventListener('klaviyoForms', this.onKlaviyoEvent.bind(this))
  }
}

customElements.define('toggleable-klaviyo-forms', ToggleableKlaviyoForms)
